// Keep the discriminator checked against the live node without loading its runtime.
const MARKER_NODE_TYPE = 'command-menu-query';
function pruneMarkerNodes(node) {
    if (!('children' in node) || !Array.isArray(node.children)) {
        return node;
    }
    const children = node.children;
    return {
        ...node,
        children: children.filter((child) => child.type !== MARKER_NODE_TYPE).map(pruneMarkerNodes),
    };
}
/**
 * Removes transient command-menu markers from a serialized draft at a storage
 * or submission boundary. Keep markers in live and controlled values: they
 * represent the open menu. This helper does not create an editor.
 *
 * @returns A snapshot with only `command-menu-query` nodes removed recursively.
 * All other text, nodes, and metadata are preserved; the input is not mutated.
 */
export function withoutCommandMenuMarker(state) {
    return { ...state, root: pruneMarkerNodes(state.root) };
}
//# sourceMappingURL=withoutCommandMenuMarker.js.map